module.exports = __webpack_public_path__ + "img/availability-ic.5c83cc23.svg";